import { Outlet } from 'react-router-dom'

import { CachedLoaderDataContextProvider } from '../../hooks/useCachedLoaderData'
import { lazyLoadComponent, parseRouteInitData } from '../../util-routing'
import Layout from './components/Layout'

export const calendarModule = [
  {
    path: '/calendar',
    loader: parseRouteInitData,
    Component: () => (
      <CachedLoaderDataContextProvider>
        <Layout>
          <Outlet />
        </Layout>
      </CachedLoaderDataContextProvider>
    ),
    children: [
      {
        path: 'economic',
        Component: lazyLoadComponent({
          chunkName: 'calendar-economic',
          load: () => import(/* webpackChunkName: "calendar-economic" */ './routes/Economic'),
        }),
      },
      {
        path: 'earnings',
        Component: lazyLoadComponent({
          chunkName: 'calendar-earnings',
          load: () => import(/* webpackChunkName: "calendar-earnings" */ './routes/Earnings'),
        }),
      },
      {
        path: 'dividends',
        Component: lazyLoadComponent({
          chunkName: 'calendar-dividends',
          load: () => import(/* webpackChunkName: "calendar-dividends" */ './routes/Dividends'),
        }),
      },
    ],
  },
]
